import { BaseApiRouteService } from "mrb/core";

class PodcastCategoryLookupApiRouteService extends BaseApiRouteService {
    constructor() {
        super("lookups/podcast-categories");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery}`, filter);
    }
}

export default PodcastCategoryLookupApiRouteService;
